import apiBase from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import Instrument from 'src/models/instrument';

export const getAllInstruments = async (): Promise<Instrument[]> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.instruments.getAll).then((response) => {
      resolve(response.data as Instrument[]);
    });
  });

export const getInstrument = async (id: number | string): Promise<Instrument> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.instruments.get(id)).then((response) => {
      resolve(response.data as Instrument);
    });
  });

export const createInstrument = async (instrument: any): Promise<Instrument> =>
  new Promise((resolve, reject) => {
    apiBase
      .post(endpoints.instruments.create, instrument)
      .then((response) => {
        resolve(response.data as Instrument);
      })
      .catch(reject);
  });

export const updateInstrument = async (instrument: any): Promise<Instrument> =>
  new Promise((resolve, reject) => {
    apiBase
      .put(endpoints.instruments.update(instrument.id), instrument)
      .then((response) => {
        resolve(response.data as Instrument);
      })
      .catch(reject);
  });

export const deleteInstrument = async (id: number | string): Promise<Instrument> =>
  new Promise((resolve, reject) => {
    apiBase.delete(endpoints.instruments.delete(id)).then((response) => {
      resolve(response.data as Instrument);
    });
  });
